// src/components/admin/TorreDeControl/ActionButtons.jsx
import React from 'react';
import {
  MapPin,
  User,
  FileText,
  DollarSign,
  Calendar,
  MessageSquare,
  CheckSquare,
  AlertCircle,
  Truck,
} from 'lucide-react';

function ActionButtons({ itemType, onActionClick }) {
  const deliveryActions = [
    { id: 'location', label: 'Ubicación', icon: MapPin, color: 'bg-blue-500' },
    { id: 'recipient', label: 'Destinatario', icon: User, color: 'bg-purple-500' },
    { id: 'delivery-data', label: 'Datos Entrega', icon: FileText, color: 'bg-indigo-500' },
    { id: 'payments', label: 'Pagos', icon: DollarSign, color: 'bg-green-500' },
    { id: 'postpone', label: 'Posponer', icon: Calendar, color: 'bg-orange-500' },
    { id: 'whatsapp', label: 'WhatsApp', icon: MessageSquare, color: 'bg-emerald-500' },
    { id: 'submitted', label: 'Submitted', icon: CheckSquare, color: 'bg-teal-500' },
    { id: 'status', label: 'Estado', icon: AlertCircle, color: 'bg-yellow-500' },
    { id: 'driver', label: 'Motorizado', icon: Truck, color: 'bg-cyan-500' },
  ];

  const orderActions = [
    { id: 'location', label: 'Ubicación', icon: MapPin, color: 'bg-blue-500' },
    { id: 'order-data', label: 'Datos Orden', icon: FileText, color: 'bg-indigo-500' },
    { id: 'submitted', label: 'Submitted', icon: CheckSquare, color: 'bg-teal-500' },
    { id: 'status', label: 'Estado', icon: AlertCircle, color: 'bg-yellow-500' },
    { id: 'driver', label: 'Motorizado', icon: Truck, color: 'bg-cyan-500' },
  ];

  const actions = itemType === 'delivery' ? deliveryActions : orderActions;

  return (
    <div className="bg-slate-50 rounded-lg p-4">
      <h3 className="text-sm font-bold text-slate-800 mb-3 font-montserrat">
        Acciones Rápidas
      </h3>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        {actions.map((action) => {
          const Icon = action.icon;
          return (
            <button
              key={action.id}
              onClick={() => onActionClick(action.id)}
              className={`${action.color} min-w-0 hover:opacity-90 text-white p-3 rounded-lg flex flex-col items-center justify-center gap-1 transition-all hover:scale-105`}
            >
              <Icon className="w-5 h-5" />
              <span className="break-words text-center text-xs font-medium font-montserrat">
                {action.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ActionButtons;
